package com.evoapps.evoshift.domain.model

import kotlinx.serialization.Serializable

// domain/model/shift/SwapRequest.kt
@Serializable
data class SwapRequest(
    val status: SwapStatus,
    val initiatorUserId: String,
    val initiatorName: String, // For UI: "Jan Kowalski"
    val candidateUserId: String?,
    val candidateName: String?, // For UI: "Marek Nowak"
    val managerNote: String?,
    val createdAt: String,
    /** SH-165: the initiator's optional note ("I have a doctor's appointment"), for the manager and the colleague. */
    val initiatorNote: String? = null
) {
    companion object {
        /** SH-165: the longest note kept (firestore.rules agree). */
        const val MAX_NOTE = 300
    }
}

@Serializable
enum class SwapStatus {
    REQUESTED_BY_OWNER,     // Jan wants to give away (Mode C/D)
    AVAILABLE,              // On the pool (Mode A/B)
    TAKEN_PENDING,          // Marek took it, waiting for approval (Mode B/D)
    REJECTED                // Manager said no
}



/** What claiming a marketplace shift did; the workplace swap policy decides which. */
enum class ClaimOutcome {
    /** Direct policies (A, C): the shift is the claimant's now. */
    ASSIGNED,
    /** Approval policies (B, D): parked as TAKEN_PENDING until a manager decides. */
    PENDING_APPROVAL
}

/** Why a claim was refused; the server decides, the UI explains. */
enum class ClaimRefusal {
    /** Not on the marketplace (any more): taken by someone else, withdrawn or not yet approved. */
    NOT_AVAILABLE,
    /** The claimant's own shift or request. */
    OWN_SHIFT,
    /** The claimant already works at that time (any workplace). */
    OVERLAP
}

class ClaimRefusedException(val reason: ClaimRefusal) : Exception("Claim refused: $reason")
